import { TerminalButton, TerminalButton2 } from "@/components/Buttons"
import { config } from "@/config"

export default function PaymentInstrumentForm({
    iframeRef,
    formType,
    submit,
    clearForm,
    accountId
}: {
    iframeRef: any,
    formType: any,
    submit: any,
    clearForm: any,
    accountId: any
}) {
    let showForm = formType === 'card-form' || formType === 'bank-form'
    return (
        <div>
            {showForm &&
                <>
                    <iframe
                        ref={iframeRef}
                        src={`${config.tokenizationBaseUrl}/` + formType + `?accountId=${accountId}`}
                        title="Tokenization form"
                        style={{ width: '100%', height: '0px' }}
                    ></iframe>
                    <TerminalButton processing={false} onClick={submit}
                    >
                        Pay
                    </TerminalButton>
                    <TerminalButton2
                        onClick={clearForm}
                    >
                        Clear
                    </TerminalButton2>
                </>
            }
        </div>
    )
}